export const Event = {
    ChangeMapOrigin: "style-editor-changeMapOrigin",
    CaptureMapOrigin: "style-editor-captureMapOrigin",
    ChangeLayerConfig: "style-editor-changeLayerConfig",
    ChangeLayerPaintConfig: "style-editor-changeLayerPaintConfig",
    ChangeSourceConfig: "style-editor-changeSourceConfig",
    ReorderLayer: "style-editor-reorderLayer",
    SelectSource: "style-editor-selectSource",
    CloseSourceConfig: "style-editor-closeSourceConfig",
    CloseSourceLayerConfig: "style-editor-closeSourceLayerConfig",
    SelectSourceLayer: "style-editor-selectSourceLayer",
    SelectSourceLayerLayer: "style-editor-selectSourceLayerLayer",
    SelectLayer: "style-editor-selectLayer",
    ExpandLayerGroup: "style-editor-expandLayerGroup",
    CloseLayerConfig: "style-editor-closeLayerConfig",
    CollapseLayerGroup: "style-editor-collapseLayerGroup",
    ChangeLayersListDisplay: "style-editor-changeLayersListDisplay",
    ChangeLayersConfigDisplay: "style-editor-changeLayersConfigDisplay",
    DeleteLayer: "style-editor-deleteLayer",
    ChangeLayerGroup: "style-editor-changeLayerGroup",
    HideLayer: "style-editor-hideLayer",
    ShowLayer: "style-editor-showLayer",
    OpenDeleteLayerGroupModal: "style-editor-openDeleteLayerGroupModal",
    OpenLayerItemRightClickMenu: "style-editor-openLayerItemRightClickMenu",
    ToggleChatHistory: "style-editor-toggleChatHistory",
    ChangeChat: "style-editor-changeChat",
    CreateNewChat: "style-editor-createNewChat",
    DeleteChat: "style-editor-deleteChat",
    RenameChat: "style-editor-renameChat",
    StarChat: "style-editor-starChat",
    ClearChatSearch: "style-editor-clearChatSearch",
    SendChatMessage: "style-editor-sendChatMessage",
    AddChatAttachment: "style-editor-addChatAttachment",
    ExportChat: "style-editor-exportChat",
    CloseLayersPanel: "style-editor-closeLayersPanel",
    CloseSourcesPanel: "style-editor-closeSourcesPanel",
    ChangeProjection: "style-editor-changeProjection",
    CloseSettingsPanel: "style-editor-closeSettingsPanel",
    CloseVersionsPanel: "style-editor-closeVersionsPanel",
    SelectMarker: "style-editor-selectMarker",
    CloseMarkersPanel: "style-editor-closeMarkersPanel",
    ChangeMarkerConfig: "style-editor-changeMarkerConfig",
    CloseMarkerConfig: "style-editor-closeMarkerConfig",
    Undo: "style-editor-undo",
    Redo: "style-editor-redo",
    SaveMap: "style-editor-saveMap",
    PublishMap: "style-editor-publishMap",
    CreateMap: "style-editor-createMap",
    Share: "style-editor-share",
    SaveMapSuccess: "style-editor-saveMapSuccess",
    PublishMapSuccess: "style-editor-publishMapSuccess",
    CreateMapSuccess: "style-editor-createMapSuccess",
    SendChatMessageSuccess: "style-editor-sendChatMessageSuccess",
    CreateLayerGroup: "style-editor-createLayerGroup",
    RestoreVersion: "style-editor-restoreVersion",
};
export const FEEDBACK_CONTROL_ID = "posthog-feedback-control";
